class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		const isMobile = window.matchMedia('(max-width: 767px)').matches;
		const rippleSize = isMobile ? '40rem' : '64rem';

		gsap.set('.js-exclamation', {
			opacity: 0,
		});
		gsap.set('.js-exclamation .top', {
			opacity: 1,
			y: 0,
			scaleY: 1
		});
	
		gsap.set('.js-exclamation .sub', {
			opacity: 1,
			y: '1.6rem',
			scale: 1
		});

		gsap.set('.js-loading-bg-2', {
			opacity: 0
		});
	
		gsap.set('.ripple', {
			width: '2rem',
			height: '2rem',
			opacity: 0
		});
	
		gsap.set('.js-loading-bg-3', {
			opacity: 0
		});
		
		gsap.set('.js-next-img', {
			opacity: 0
		});

		gsap.set('.splash', {
			xPercent: -50,
			yPercent: -50,
			x: 0,
			y: 0,
			scale: .5,
			opacity: 0
		});

		gsap.set('.js-third-area', {
			opacity: 0
		});
		
		gsap.set('.js-object-main', {
			opacity: 0,
		});
		
		gsap.set('.js-last-area', {
			opacity: 1
		});
		
		gsap.set('.js-last-ttl', {
			opacity: 0,
			visibility: 'visible'
		});
		const tl = gsap.timeline({
			defaults: {
				ease: 'power2.out'
			}
		});

		tl.to('.js-exclamation', {
			opacity: 1,
			ease: 'power2.out'
		});
		
		// しばらく表示
		tl.to({}, {
			duration: .75
		});
			
		tl.to('.js-exclamation .top', {
			y: '-8rem',
			scaleY: .85,
			opacity: 0,
			duration: 1.0,
			ease: 'power2.out'
		}, .4);
		
		tl.to('.js-exclamation .sub', {
			y: '25rem',
			duration: .8,
			ease: 'power2.in'
		}, .4);
		
		tl.to('.js-exclamation .sub', {
			y: '8rem',
			duration: .85,
			ease: 'power3.out'
		});

		// 着水タイミング
		const splashStart = 1.2;

		tl.to('.js-loading-bg-2', {
			opacity: .8,
			duration: .55,
			ease: 'power2.out'
		}, splashStart);
		
		tl.to('.js-loading-bg-2', {
			opacity: 1,
			duration: 1.0,
			ease: 'power2.out'
		}, splashStart + .85);

		// 着水後、丸も飛沫と同じ色にする
		tl.set('.js-exclamation .sub', {
			backgroundColor: 'rgba(255,255,255,.65)'
		}, splashStart);

		tl.to('.js-exclamation .sub', {
			duration: 2.0,
			ease: 'power2.out',
			keyframes: [
				{
					opacity: .75,
					scale: 1,
					duration: .35
				},
				{
					opacity: .55,
					scale: .95,
					duration: .55
				},
				{
					opacity: 0,
					scale: .85,
					duration: 1.1
				}
			]
		}, splashStart);
				
		tl.to('.ripple:nth-child(1)', {
			width: rippleSize,
			height: rippleSize,
			opacity: 0,
			duration: 2.0,
			ease: 'power2.out',
			keyframes: [
				{ opacity: .75, duration: .35 },
				{ opacity: .45, duration: .55 },
				{ opacity: 0, duration: 1.1 }
			]
		}, splashStart);

		tl.to('.ripple:nth-child(2)', {
			width: rippleSize,
			height: rippleSize,
			opacity: 0,
			duration: 2.0,
			ease: 'power2.out',
			keyframes: [
				{ opacity: .65, duration: .35 },
				{ opacity: .35, duration: .55 },
				{ opacity: 0, duration: 1.1 }
			]
		}, splashStart + .3);
	
		const splashData = isMobile
		? [
			{ el: '.splash:nth-child(1)', x: '-18rem', y: '-8rem',  scale: 1.25, delay: 0 },
			{ el: '.splash:nth-child(2)', x: '-12rem', y: '-10rem', scale: 1.2,  delay: .03 },
			{ el: '.splash:nth-child(3)', x: '-6rem',  y: '-7rem',  scale: 1.1,  delay: .05 },
			{ el: '.splash:nth-child(4)', x: '0rem',   y: '-12rem', scale: 1.25, delay: .02 },
			{ el: '.splash:nth-child(5)', x: '6rem',   y: '-7rem',  scale: 1.1,  delay: .07 },
			{ el: '.splash:nth-child(6)', x: '12rem',  y: '-10rem', scale: 1.2,  delay: .05 },
			{ el: '.splash:nth-child(7)', x: '18rem',  y: '-8rem',  scale: 1.25, delay: .01 },
			{ el: '.splash:nth-child(8)', x: '3rem',   y: '-13rem', scale: 1.15, delay: .08 }
		]
		: [
			{ el: '.splash:nth-child(1)', x: '-30rem', y: '-12rem', scale: 1.25, delay: 0 },
			{ el: '.splash:nth-child(2)', x: '-20rem', y: '-16rem', scale: 1.2,  delay: .03 },
			{ el: '.splash:nth-child(3)', x: '-9rem',  y: '-11rem', scale: 1.1,  delay: .05 },
			{ el: '.splash:nth-child(4)', x: '0rem',   y: '-18rem', scale: 1.25, delay: .02 },
			{ el: '.splash:nth-child(5)', x: '9rem',   y: '-11rem', scale: 1.1,  delay: .07 },
			{ el: '.splash:nth-child(6)', x: '20rem',  y: '-16rem', scale: 1.2,  delay: .05 },
			{ el: '.splash:nth-child(7)', x: '30rem',  y: '-12rem', scale: 1.25, delay: .01 },
			{ el: '.splash:nth-child(8)', x: '4rem',   y: '-20rem', scale: 1.15, delay: .08 }
		];
	
		splashData.forEach((item) => {
			tl.to(item.el, {
				x: item.x,
				y: item.y,
				scale: item.scale,
				duration: 2.0,
				ease: 'power2.out',
				keyframes: [
					{
						opacity: .75,
						duration: .35
					},
					{
						opacity: .55,
						duration: .55
					},
					{
						opacity: 0,
						duration: 1.1
					}
				]
			}, splashStart + item.delay);
		});

		const objectStart = splashStart + 1.55;

		// js-object：水面位置から表示
		tl.to('.js-third-area', {
			opacity: 1,
			duration: .01
		}, objectStart);
		
		// オーバルを波紋の近くから、じわっと湧き出るように表示
		// tl.fromTo('.js-object-main',
		// 	{
		// 		opacity: 0,
		// 		y: '10rem',
		// 		scaleY: 0.9,
		// 		transformOrigin: 'center bottom'
		// 	},
		// 	{
		// 		opacity: 1,
		// 		y: '3rem',
		// 		scaleY: 1,
		// 		duration: 2.4,
		// 		ease: 'power2.out'
		// 	},
		// 	objectStart
		// );
		
		// js-object：水面位置から表示
		tl.to('.js-third-area', {
			opacity: 1,
			duration: .01
		}, objectStart);

		// 親要素を必ず表示状態に戻す
		tl.set('.js-object', {
			opacity: 1,
			y: 0
		}, objectStart);

		// オーバル本体の初期化
		tl.set('.js-object-main', {
			opacity: 0,
			y: '10rem',
			scaleY: 0.9,
			transformOrigin: 'center bottom'
		}, objectStart);

		// 出現位置から止まらず、ゆっくり一定速度で上昇
		tl.to('.js-object-main', {
			y: '-52%',
			scaleY: 1,
			duration: 5.4,
			ease: 'none'
		}, objectStart);

		// 出始めはじわっとフェードイン
		tl.to('.js-object-main', {
			opacity: 0.75,
			duration: 2.4,
			ease: 'power2.out'
		}, objectStart);

		tl.to('.js-object-main', {
			opacity: 0,
			duration: 2.2,
			ease: 'power1.out'
		}, objectStart + 1.0);
		
		tl.to('.js-object', {
			opacity: 0,
			duration: 2.2,
			ease: 'power1.out'
		}, objectStart + 1.0);

		// オブジェクト全体も同じ速度で上昇
		tl.to('.js-object', {
			y: '-45%',
			duration: 5.0,
			ease: 'none'
		}, objectStart);

		tl.to('.js-last-ttl', {
			opacity: 0.5,
			duration: 0.9,
			ease: 'power2.out'
		}, objectStart + 1.35);

		tl.to('.js-last-ttl', {
			opacity: 1,
			duration: 1,
			ease: 'power2.out'
		}, objectStart + 1.85);
		
		// bg-3が出る前に、文字を先に完全に消す
		tl.to('.js-last-ttl', {
			opacity: 0,
			duration: 0.6,
			ease: 'power2.out'
		}, objectStart + 4);

		tl.set('.js-last-ttl', {
			visibility: 'hidden'
		}, objectStart + 5);

		tl.to('.js-loading-bg-3', {
			opacity: 1,
			duration: 1.2,
			ease: 'power2.out'
		}, objectStart + 4.2);

		tl.to('.js-loading-bg-3', {
			opacity: 0,
			duration: 1.2,
			ease: 'power2.out'
		}, objectStart + 4.7);

		tl.to('.js-next-img', {
			opacity: 1,
			duration: 1.2,
			ease: 'power2.out'
		}, objectStart + 4.7);

		tl.timeScale(0.85);
  }
}
